import swiperPropertyItem from "./swipers/swiperPropertyItem";
import swiperPropertyQuickView from "./swipers/swiperPropertyQuickView";
import swiperPropertySingle from "./swipers/swiperPropertySingle";
import swiperPropertyListing from "./swipers/swiperPropertyListing";
import swiperPropertyGalleryGrid from "./swipers/swiperPropertyGalleryGrid";
import swiperListingCards from "./swipers/swiperListingCards";
import swiperStickyCta from "./swipers/swiperStickyCta";
import swiperFullFade from "./swipers/swiperFullFade";

export default function initSwipers() {
    swiperPropertyItem();
    swiperPropertyQuickView();
    swiperPropertySingle();
    swiperPropertyListing();
    swiperPropertyGalleryGrid();
    swiperListingCards();
    swiperStickyCta();
    swiperFullFade();
}
